<template>
  	<div class="login-container">
		<h1 class="form-title">{{title}}</h1>
	    <form action class="form" @submit.prevent="login">
	    	<div class="form-group">
	    		<label for="email">Email</label>
		      	<input class="form-input pl-3" type="email" name="email" required placeholder="Email" v-model="loginFormModel.email">
		      	<div v-if="veeErrors.has('email')" class="alert alert-danger py-0 mt-2 mb-0" role="alert">
		      		Email is required!
	          	</div>
	    	</div>
	    	<div class="form-group">
	    		<label for="password">Contraseña</label>
	      		<input class="form-input pl-3 password" name="password" :type="visibility" required placeholder="Contraseña" v-model="loginFormModel.password">
	      		<!-- shows the password -->
	            <a @click="showPassword()" class="password-icon" v-if="visibility == 'password'">
	                <font-awesome-icon icon="eye" />
	            </a>
	            <!-- hide the password -->
	            <a @click="hidePassword()" class="password-icon" v-if="visibility == 'text'">
	                <font-awesome-icon icon="eye-slash" />
	            </a>
	      		<div v-if="veeErrors.has('password')" class="alert alert-danger py-0 mt-2 mb-0" role="alert">
	      			Password is required!
	      		</div>
	    	</div>
	    	<div class="col-sm-6 text-left float-left">
	    		<button class="btn btn-primary form-submit" type="submit">Login</button>
	    	</div>
	    	<div class="col-sm-6 text-right float-left">
	    		<router-link :to="{path: '/survey'}" class="btn btn-secondary link">
					Ir a encuesta
				</router-link>
	    	</div>
	      	<div class="container" v-if="message" style="padding-top: 25px;">
	          	<div class="alert alert-danger" role="alert">
		          	{{message}}
		      	</div>
	        </div>
	    </form>
	</div>
</template>

<script>
  	import LoginFormModel from '@/models/loginForm.model';
	export default {
		name: 'Login',
		components: {
	    },
		data() {
		  return {
		    loginFormModel: new LoginFormModel('', ''),
		    message: '',
		    title: '¡BIENVENIDAS!',
		    visibility: 'password'
		  };
		},
		computed: {
		  loggedIn() {
		    return this.$store.state.auth.status.loggedIn;
		  }
		},
		created() {
		  if (this.loggedIn && this.$store.state.auth.user != null) {
			this.$router.push('/dashboard');
		  }
		},
		methods: {
		  	login() {
		      if (this.loginFormModel.email && this.loginFormModel.password) {
		        this.$store.dispatch('auth/login', this.loginFormModel).then(
		         	(response) => {
						if(response.status != undefined && response.status == 401){
							this.message = response.message
						} else {
							this.$router.push('/dashboard');
						}
	          		}, error => {
			            this.message = error.response.data.message
			            console.log(
	             		(error.response && error.response.data) ||
		              	error.message ||
		              	error.toString());
		          	}
		        );
		      }
		    },
		  	showPassword() {
				this.visibility = 'text';
			},
			hidePassword() {
				this.visibility = 'password';
			}
		}
	};
</script>

<style type="text/css">
    
</style>